import "@mui/material/styles";
import SystemIconButton from "@mui/material/IconButton";
import { styled } from "../../styles/index.js";
import { rootShouldForwardProp } from "@mui/material/styles/styled";
const IconButtonRoot = styled(SystemIconButton, {
  shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
  name: "TrueIconButton",
  slot: "Root"
})(({ theme, ownerState }) => {
  const palette = theme.palette[ownerState.color] || theme.palette.secondary;
  return {
    padding: theme.spacing(ownerState.size === "small" ? 1 : 1.5),
    borderRadius: theme.spacing(1),
    ...ownerState.color === "inherit" && {
      color: "inherit",
      background: "inherit",
      borderColor: "inherit",
      "&:hover": {
        color: "inherit",
        background: "inherit",
        borderColor: "inherit"
      }
    },
    ...ownerState.variant === "contained" && {
      backgroundColor: palette.main,
      "&:hover": {
        background: palette.dark
      }
    },
    ...ownerState.variant === "outlined" && {
      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: palette.main,
      background: "transparent",
      "&:hover": {
        background: palette.dark,
        borderColor: palette.dark
      }
    }
  };
});
export {
  IconButtonRoot
};
//# sourceMappingURL=icon-button.styles.js.map
